import React from 'react'
import { Route, IndexRedirect } from 'react-router'
import IndexPage from './pages/IndexPage'
import LoginPage from './pages/LoginPage'
import OpportunitiesPage from './pages/OpportunitiesPage'
import OpportunityPage from './pages/OpportunityPage'
import OrganizationPage from './pages/OrganizationPage'
import VipPage from './pages/VipPage'
import NotFound from './pages/NotFound'

export const loginUrl = `${process.env.REACT_APP_API}/account/oauth2/google/redirect`

export default (
  <Route path="/" component={IndexPage}>
    <IndexRedirect to="/opportunities" />
    <Route path="login(/:status)" component={LoginPage} />
    <Route path="opportunities(/:page(/:id))" component={OpportunitiesPage} />
    <Route path="opportunity/:id" component={OpportunityPage} />
    <Route path="organization/:id" component={OrganizationPage} />
    <Route path="vip/:form" component={VipPage} />
    <Route path="*" component={NotFound} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js